//
// GStrediskaTab.ts
//
// Sdilena obsluha TABu pro zobrazení vazebních dat na strediska spisovych uzlu - na detail oknech
// možnost hromadně přidávat a odebírat řádky ( střediska )
// Použito na 
//      DetailAdmTypDokumentu.ts
//      DetailAdmZpusobVyrizeni.ts

namespace Gordic.Adm.WebControls {
    export interface GStrediskaOptions {
        
    }

    export class GStrediskaTab {
        private actions: GActionList;
        private gtabStrediska: JQuery<HTMLElement>;
        private gridStrediska: JQuery<HTMLElement>;

        // vytvori tab
        constructor(/*params: GStrediskaOptions*/) {
            this.createActions();
            if (this.gtabStrediska != undefined)
                this.gtabStrediska.remove();

            this.gtabStrediska = $("<div>")/*.appendTo(this.element)*/
            var tab = $("<div>").appendTo(this.gtabStrediska).gtab({
                title: "jres:33000008", //RC 33000008 : Střediska spisových uzlů
                opened: true,
                locked: true,
                menuBar: [
                    {
                        favorite: true,
                        action: this.actions.actAddStredisko,
                    },
                    {
                        favorite: true,
                        action: this.actions.actRemoveStredisko,
                    }
                ]
            })

            // vytvori grid a jeho sloupce
            this.gridStrediska = $("<div>").appendTo(tab).gautofit({ resizersOnTab: true, minimalHeight: 400 }).ggrid({
                multi: true,
                rowsCheckEnabled: (m) => { return false },
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        caption: "jres:32131029",
                        name: "ixs_tre_txt"
                    })
                    .addTextColumn({
                        caption: "jres:29930689",
                        name: "poznamka",
                        editor: { widget: "gstringbox" }
                    })
            }).ggridroweditor()

            this.gtabStrediska.hide();
        }

        // vrátí tab
        public getTab(): JQuery<HTMLElement> {
            return this.gtabStrediska;
        }

        // Nastaví přístupnost tlačítek nad gridem
        public updateStrediskaAction(enable: boolean) {
            this.actions.actAddStredisko?.update({ enabled: enable });
            this.actions.actRemoveStredisko?.update({ enabled: enable });
            this.gtabStrediska.findFields().gfield("option", { disabled: !enable})
        }

        // nastaví data do gridu
        public setDataTogrid(data: any) {
            this.gridStrediska.ggrid("setData", []);
            if (data != undefined)
                this.gridStrediska.ggrid("setData", data)
        }

        // načte data z gridu
        public getDataFromGrid(): any[] | null {
            if (this.gtabStrediska.is(":visible")) {
                var view = this.gridStrediska.ggrid("getView");
                var strediska = view.getDataRows(false, "data");
                return strediska
            }
            else
                return null
        }

        // zmeni viditelnost tabu
        public changeVisible(hide: boolean) {
            if (hide == true) 
                this.gtabStrediska.hide();
            else
                this.gtabStrediska.show();
        } 

        // odstrani oznacene radky z gridu
        private removeStrediska() {
            var data = this.gridStrediska.ggrid("getSelection");
            var view = this.gridStrediska.ggrid("getView");
            data.forEach((d) => {
                view.updateData(d, "delete");
            })
            this.gridStrediska.ggrid("setData", view);
        }

        // vytvori a zobrazi modalni vyberove okno se seznamem stredisek
        private createModalStrediska() {
            GDlg.showModalWindow("Gordic.Adm.WebControls.SelectStrediskaModalWindow", null, { width: 600, height: 450 }).on("close", (o, result) => {
                if (result != null && result != undefined) {
                    if (result.length != 0) {
                        var newStr = new Array();
                        var view = this.gridStrediska.ggrid("getView");
                        var data = view.getDataRows(false, "data");
                        for (var i = 0; i < result.length; i++) {
                            if (data.filter(v => v.ixs_tre == result[i].ixs_tre).length == 0)
                                newStr.push({ ixs_tre: result[i].ixs_tre, ixs_tre_txt: result[i].nazev, poznamka: "" });
                        }
                        newStr.forEach((str) => {
                            view.updateData(str, "add");
                        })
                        this.gridStrediska.ggrid("setData", view);
                    }
                }
            })
        }

        // vytvoření tlačítek nad gridem
        private createActions() {
            this.actions = new GActionList([]);
            this.actions.addRange({
                actAddStredisko:
                {
                    icon: "fa-plus",
                    caption: "jres:33000006", //RC 33000006 : Přidat střediska
                    enabled: false,
                    run: () => {
                        this.createModalStrediska();
                    }
                },
                actRemoveStredisko:
                {
                    icon: "fa-minus",
                    caption: "jres:33000007", //RC 33000007 : Odebrat středisko
                    enabled: false,
                    run: () => {
                        this.removeStrediska()
                    }
                }
            })
        }

       
    }
}